export default __webpack_public_path__ + "static/media/empty-shoppingcart.9ce8c274.png";